import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import apiRequest from "../services/api";

function AppInitializer({ children }) {
  const token = useSelector((state) => state?.auth?.token);
  const navigate = useNavigate();
  const hasChecked = useRef(false);

  useEffect(() => {
    // Only check once, only when logged in
    if (token && !hasChecked.current) {
      hasChecked.current = true;

      const checkGseriesTransaction = async () => {
        try {
          const response = await apiRequest({
            method: "GET",
            endpoint: "api/transactions/gseries-transaction",
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          });

          if (response?.data?.data === true) {
            navigate("/select_product");
          }
        } catch (error) {
          console.error("Error checking gseries transaction:", error);
        }
      };

      checkGseriesTransaction();
    }
  }, [token, navigate]);

  return children;
}

export default AppInitializer;
